module.exports = __webpack_public_path__ + "static/img/tip-4.5795ca6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt5/tip-4.png
// module id = Rg/T
// module chunks = 1